import styled from "styled-components";

const Button = styled.button`
    width: 100%;
    height: 45px;
    background-color: var(--background-button);
    border-radius: 4.63636px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: var(--white);
    font-family: 'Lexend Deca', sans-serif;
    padding: 14px;
    font-weight: 400;
    font-size: 20.976px;
    line-height: 26px;
`;

export default Button;